import axios from "axios";
import store from "../store";
import { Message } from "element-ui";
var instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "/api"
      : `${window.location.protocol}//${window.location.host}`,
  headers: { "Content-Type": "application/json;charset=UTF-8" }
});
instance.interceptors.request.use(
  function(config) {
    config.url = "/v3/api" + config.url;
     // 从本地存储中获取 token
    const token = store.getters['user/getToken']
    config.headers['user-token'] = `${token}` 
    return config;
  },
  function(error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  function(response) {
    var data = response.data;
    var requestConfig = response.config || {};
    if(data.errCode=='500') {
      // 页面需要自己拼「新建失败：…」时传 resolveErrorDataOnBizError，避免拦截器先弹一层再被页面弹第二层
      if (requestConfig.resolveErrorDataOnBizError) {
        return data;
      }
      Message({
        type: "error",
        message: data.errMessage,
        duration: 5000,
        showClose:true
      });
      return Promise.reject(data);
    }
    return data;
  },
  function(error) {
    let {status}=error.response
    if (status==401){
      location.href='/#/login'
      store.commit('user/LOG_OUT')
      location.reload()
      Message({
        type: "info",
        message: 'token已过期,请重新登陆'
      });
      return;
    }
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
export default instance;
